<template>
    <div>
        <div class="row align-items-center">
            <form-field ref="descricao" v-model="motivocrm.descricao" type="text" col="6" :metadata="metadata.motivocrm.descricao" 
                name="descricao" :v-errors="errors" v-validate="metadata.motivocrm.descricao.validator"></form-field>
            <div class="col-md-4 col-6">
                <v-button label="Salvar" :nb-btdef="true" @click="handleSave"></v-button>
                <v-button label="Cancelar" @click="closeForm"></v-button>
            </div>
        </div>
    </div>
</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'
import apiCrm from '../api/api-crm.js'

export default {
    props: {
        index: '',
        crud: '',
    },

    data() {
        return {
            crudText: '',
            motivocrm: {...this.$store.getters.getEntities.motivocrm},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }

    },

    methods: {
        closeForm (motivo) {
            this.$emit('closeform', motivo)
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiMotivo(this.motivocrm, this.motivocrm.codmotivo, this.callBackPost)
                }
            })
        },

        callBackPost (motivo) {
            this.$erpToastSuccess('Motivo gravado com sucesso')
            this.closeForm(motivo)
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadMotivoCrm', { id: this.index } )
            if (this.$store.getters.getMotivoCrm) {
                this.motivocrm = {...this.$store.getters.getMotivoCrm}
            }  
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

    },

    components: {

    },

    beforeCreate () {

    },

    created () {
        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
        } else {
            this.loadData()  
        }
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
            this.$refs.descricao.focus()
        })
    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms-crm/crm-motivo-form.vue